export const JOURNEYS_ENDPOINTS = {
   GET_ALL: () => '/journeys',
};
